import styled from 'styled-components';
export const Container = styled.div`
  background-color:#e8e8e8;
  width: 100%;
  height: 100%;
  display:flex;
  flex-direction: row;
  border-radius: 8px;
  input{
    width: 100%;
    margin-right:10px;
    border: none;
    outline:none;
    justify-content: left;
    background-color: transparent;
  }
`
export const Icon = styled.label`
  width: 2rem;
  height: 100%;
  color:#495057;
  display: flex;
  align-items: center;
  padding: 0.5rem;
  background: transparent;
  font-size: 1.5rem;
  font-weight: 500;
  margin-left: 0.3rem;
`